// biome-ignore lint/style/useFilenamingConvention: it will be fixed soon

import { decorateIcons } from '../../scripts/aem.js';
import { div, input, li, span, ul } from '../../scripts/dom-builder.js';
import { highlight } from '../../scripts/utils/fuse-search-utils.js';

function dispatchSearchEvent(searchValue) {
  const searchEvent = new CustomEvent('searchEvent', {
    detail: { searchValue },
  });
  document.dispatchEvent(searchEvent);
}

function hideAutocompleteList(autocompleteList) {
  autocompleteList.classList.remove('hero__content__autocomplete-list-visible');
  autocompleteList.innerHTML = '';
}

function getMatchIndicesLength(match) {
  return match.indices.reduce(
    (sum, [start, end]) => sum + (end - start + 1),
    0,
  );
}

export function getBestMatch(matches) {
  if (!matches || matches.length === 0) {
    return '';
  }

  let bestMatch = matches[0];
  let bestMatchLength = getMatchIndicesLength(bestMatch);

  matches.slice(1).forEach((currentMatch) => {
    const currentMatchLength = getMatchIndicesLength(currentMatch);

    if (currentMatchLength > bestMatchLength) {
      bestMatch = currentMatch;
      bestMatchLength = currentMatchLength;
    }
  });

  return bestMatch;
}

function getIsEnterOrSpace(event) {
  return event.key === 'Enter' || event.key === ' ';
}

function handleSearch(searchInput) {
  dispatchSearchEvent(searchInput.value);
}

function handleClear(searchInput, autocompleteList) {
  searchInput.value = '';
  searchInput.classList.remove('has-text');
  dispatchSearchEvent('');
  hideAutocompleteList(autocompleteList);
}

function updateAutocomplete(
  // eslint-disable-line no-unused-vars
  autocompleteList,
  searchInput,
  results,
) {
  if (!results.length) {
    autocompleteList.classList.remove(
      'hero__content__autocomplete-list-visible',
    );
    return;
  }

  autocompleteList.classList.add('hero__content__autocomplete-list-visible');
  autocompleteList.innerHTML = '';

  const listTitle = span({ class: 'hero__content__autocomplete-title' });
  listTitle.textContent = 'suggested searches';
  autocompleteList.append(listTitle);

  results.forEach((matchResult) => {
    const listItem = li({ class: 'hero__content__autocomplete-item' });
    const searchIcon = span({ class: 'icon icon-search' });

    const bestMatch = getBestMatch(matchResult.matches);
    const itemText = matchResult.item[bestMatch.key];

    const highlightedTextWrapper = span();
    highlightedTextWrapper.innerHTML = highlight(itemText, bestMatch);
    listItem.append(searchIcon, highlightedTextWrapper);

    listItem.addEventListener('click', () => {
      searchInput.value = itemText;
      dispatchSearchEvent(itemText);
      hideAutocompleteList(autocompleteList);
    });
    autocompleteList.appendChild(listItem);
  });
}

export default function addSearchInput({
  hero,
  contentContainer,
  searchPlaceholder,
}) {
  hero.querySelector('.hero__content__eyebrow')?.remove();
  hero.querySelector('.hero__additional-content')?.remove();
  hero.querySelector('.hero__content__info')?.remove();

  const searchInputPlaceholder =
    contentContainer.querySelector('h6')?.previousElementSibling;
  const searchInputContainer = div({
    class: 'hero__content__input-container',
    role: 'search',
  });
  const searchAutocompleteList = ul({
    class: 'hero__content__autocomplete-list',
  });
  const searchInput = input({
    class: 'hero__content__input',
    placeholder:
      searchPlaceholder ||
      searchInputPlaceholder?.textContent ||
      'Search for your SAP product here',
  });

  searchInput.addEventListener('input', () => {
    const searchValue = searchInput.value;

    if (searchValue.length >= 1) {
      searchInput.classList.add('has-text');
    } else {
      searchInput.classList.remove('has-text');
    }

    dispatchSearchEvent(searchValue);
  });

  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      dispatchSearchEvent(searchInput.value);
    }
  });

  // TODO: uncomment, please, for autocomplete functionality
  // document.addEventListener('searchResults', (e) => {
  //   const { results } = e.detail;
  //   updateAutocomplete(searchAutocompleteList, searchInput, results);
  //   decorateIcons(searchAutocompleteList);
  // });

  document.addEventListener('click', (event) => {
    if (
      !searchInput.contains(event.target) &&
      !searchAutocompleteList.contains(event.target)
    ) {
      hideAutocompleteList(searchAutocompleteList);
    }
  });

  const heroContentEl = hero.querySelector('.hero__content');
  const searchIcon = span({
    class: 'icon icon-search',
    role: 'button',
    'aria-hidden': 'true',
  });
  const clearIcon = span({
    class: 'icon icon-close',
    role: 'button',
    tabindex: '0',
    'aria-label': 'decline',
  });

  clearIcon.addEventListener('click', () => {
    searchInput.value = '';
    searchInput.classList.remove('has-text');
    dispatchSearchEvent('');
    hideAutocompleteList(searchAutocompleteList);
  });

  clearIcon.addEventListener('keydown', (e) => {
    if (getIsEnterOrSpace(e)) {
      e.preventDefault();
      handleClear(searchInput, searchAutocompleteList);
    }
  });

  searchIcon.addEventListener('click', () => {
    dispatchSearchEvent(searchInput.value);
  });

  searchIcon.addEventListener('keydown', (e) => {
    if (getIsEnterOrSpace(e)) {
      e.preventDefault();
      handleSearch(searchInput);
    }
  });

  searchInputContainer.append(
    searchInput,
    clearIcon,
    searchIcon,
    searchAutocompleteList,
  );
  heroContentEl.append(searchInputContainer);
  decorateIcons(heroContentEl);
}
